import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const items = [
  "FREE SHIPPING OVER $50",
  "3RD PARTY TESTED BY EUROFINS",
  "cGMP MANUFACTURED IN THE USA",
  "SUBSCRIBE & SAVE 15%",
];

export default function AnnouncementBar() {
  const [i, setI] = useState(0);
  useEffect(() => {
    const id = setInterval(() => setI((p) => (p + 1) % items.length), 3800);
    return () => clearInterval(id);
  }, []);
  return (
    <div className="w-full bg-[#0f0f10] text-[#faf9f5]" data-testid="announcement-bar">
      <div className="max-w-site mx-auto px-6 md:px-10 h-9 flex items-center justify-center overflow-hidden">
        <AnimatePresence mode="wait">
          <motion.span
            key={i}
            initial={{ opacity: 0, y: 6 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -6 }}
            transition={{ duration: 0.45 }}
            className="label !text-[10.5px] !text-[#faf9f5]/90"
          >
            {items[i]}
          </motion.span>
        </AnimatePresence>
      </div>
    </div>
  );
}
